import { SET_CONSENT } from '../actions/gdpr-actions';

const initialState = {
  consent: null,
};

const gdprReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_CONSENT:
      return {
        ...state,
        consent: action.consent,
      };
    default:
      return state;
  }
};

export default gdprReducer;
